
import TransferDom from 'vux/src/directives/transfer-dom/index.js'


import common from "@/assets/js/Common.js";
import api from "@/assets/js/Api.js";

import navbar from '@/components/ui/navbar'
import loadmore from '@/components/ui/loadmore'
import cardbox from '@/components/ui/cardbox'
import buttonbox from '@/components/ui/buttonbox'

import shopCart from '@/components/cusShopCart'
import mainMenuTab from '@/components/mainMenuTab'

export default {
components: {
shopCart, mainMenuTab, navbar, loadmore, cardbox, buttonbox,
},
directives: {
TransferDom
},
data(){
return {
addrDialog: {
show: false,
store: {},
},
couponDialog: {
show: false,
store: {},
},
dataList: [],
settle:{
price: 0,
quantity: 0,
deposit: 0,
spec_id: [],
},
orderPrice: {
price: 0,
deposit: 0,
quantity: 0,
shipping: 0,
}

}
},
methods:{

submitOrder(){


const _this = this;
let data = [];

let isAddrState = true;  

this.dataList.forEach(store=>{

let spec_id = [];
store.items.forEach(goods=>{
spec_id.push(goods.spec_id);
})

if(store.express_type===1 && !store.addr_id){
isAddrState = false;
this.$vux.toast.text(store.store.store_name+" 未选择收货地址",'top')
return;
}

data.push({
store_id: store.store.store_id,
store_name: store.store.store_name,
addr_id: store.addr_id,
coupon: store.coupon.coupon_sn || "",
express_type: store.express_type,
user_message: store.user_message,
spec_id: spec_id,
storePrice: store.storePrice,
storeQuantity: store.storeQuantity,
storeDeposit: store.storeDeposit,
storeShipping: store.storeShipping,
storeCoupon: store.coupon,
});
console.log(data,this.couponDialog);
})

if(!isAddrState) return;



this.$vux.confirm.show({
title: '提示',
content: '提交订单时请检查地址是否选择正确, 点击确认提交订单',
onConfirm () {
common.sessionJson('orderConfirm',data[0]);
_this.$router.push("/pay/wx/");
}
})

},


selectCoupon(couponObj){

this.couponDialog.store.coupon = couponObj;
this.couponDialog.show = false;
},


changeCoupon(store){

this.couponDialog.store = store;
this.couponDialog.show = true;
},


selectAddress(addr){

this.addrDialog.store.addr_id = addr.addr_id;
this.addrDialog.show = false;

},


changeAddress(store){
this.addrDialog.store = store;
this.addrDialog.show = true;
},


selectShipping(item,type){
item.express_type = type;

let shipping = 0;
this.dataList.forEach(val=>{
if(val.express_type==1){
shipping += val.storeShipping;
}
});

this.orderPrice.shipping = shipping;
},


queryOrderInfo(){
const opts = {
url: api.cartToSubmit,
data: {
spec_id: this.$route.query.spec_id,
storeId: common.getCurStoreId(),
},
type: 'get',
}
common.query(opts).then(res=>{

this.initOrderList(res.data);

},res=>{
this.$vux.toast.text(res.message);
})
},


initOrderList(data){


let list = [];
let countPrice = 0,countDeposit = 0, countQuantity = 0, countShipping = 0;
for(let row in data.store){

let storePrice = 0,storeDeposit = 0,storeQuantity = 0;
data.items[row].forEach(val=>{
storePrice += parseInt(val.total);
storeDeposit += parseInt(val.deposit);
storeQuantity += parseInt(val.quantity);
});

countPrice += storePrice;
countDeposit += storeDeposit;
countQuantity += storeQuantity;
countShipping += data.shippingFee[row].total;

let defaultAddr = 0;
data.address.forEach(val=>{
if(val.is_default){
defaultAddr = val.addr_id;
}
})

list.push({
store: data.store[row],
items: data.items[row],
error: data.error[row],
available_coupon: data.available_coupon[row],
shippingFee: data.shippingFee[row],
address: data.address,
express_type: 1,
user_message: '',
addr_id: defaultAddr,
coupon: {},
storePrice: storePrice,
storeDeposit: storeDeposit,
storeQuantity: storeQuantity,
storeShipping: data.shippingFee[row].total,
})
}
this.orderPrice = {
price: countPrice,
deposit: countDeposit,
quantity: countQuantity,
shipping: countShipping,
}
this.dataList = list;
console.log(list);
}

},
mounted(){
this.queryOrderInfo()
},
}



// WEBPACK FOOTER //
// ./src/views/member/orderConfirm.vue